var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-06-22
 * @brief SEI Report 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// recoil
import { alertState, curReportState, curTotalState, mainState, reportTypeState } from "@recoil/assessmentState";
import { loadingBoxState } from "@recoil/menuState";
import { reLoadState, reloadSpg, userInfoLoginState } from "@recoil/userState";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
// utils
import * as HTTPUTIL from "@utils/api/HttpUtil";
import * as CUTIL from "@utils/commUtils";
import * as CONST from "@utils/Const";
import * as FILEUTILS from "@utils/file/fileUtil";
import EhpPagination from "../../common/pagination/EhpPagination";
// datepicker
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { enUS, ko } from "date-fns/esm/locale";
// 압축 다운로드
import ReportBasketsPop from "@components/dashBoard/report/ReportBasketsPop";
import { langId, langState } from "@recoil/langState";
import { useTrans } from "@utils/langs/useTrans";
import axios from "axios";
import JSZip from "jszip";
function ReportView(props) {
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const langs = useRecoilValue(langState); // recoil langState
    const langIds = useRecoilValue(langId);
    const [reloadspg, setReloadspg] = useRecoilState(reloadSpg);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curReportState);
    const setReloadState = useSetRecoilState(reLoadState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [recoilState, setRecoilState] = useRecoilState(mainState);
    const recoilTreeTotal = useRecoilValue(curTotalState);
    //props
    const { handleOpenPop, isMobile, treeSel, setWork, basketsItem, setBasketsItem, setSuccess } = props;
    const [memo, setMemo] = useState(false);
    const [listMemo, setListMemo] = useState(null);
    const [repop, setRepop] = useState(false);
    const [checkItem, setCheckItem] = useState([]);
    const [checkArr, setCheckArr] = useState([]);
    const [toogle, setToogle] = useState(false);
    const [treeItem, setTreeItem] = useState([]);
    const [reportItem, setReportItem] = useState([]);
    const [averageToogle, setAverageToogle] = useState(false);
    const [roomInfo, setRoomInfo] = useState([]);
    const [spgInfo, setSpgInfo] = useState([]);
    const [curTree, setCurTree] = useState(null);
    // 페이징
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    // 검색
    const searchFieldList = [
        { id: 1, sfDisp: t("라벨.형명"), sfVal: "itemName" },
        { id: 2, sfDisp: t("라벨.시리얼번호"), sfVal: "serialNo" },
        { id: 3, sfDisp: t("라벨.메모"), sfVal: "memo" } /* assessmentMemo */,
        { id: 4, sfDisp: t("라벨.상세유형"), sfVal: "checkSubTypeName" },
    ];
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState({
        searchField: "",
        searchText: "",
    });
    const [searchInit, setSerarchInit] = useState(searchFieldList[0]);
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "createdTime",
        sort: "desc",
    });
    const dateTermList = [
        { id: 0, dtDisp: t("라벨.직접입력"), dateFormats: "null", dtVal: 0 },
        { id: 1, dtDisp: t("라벨.T_월", ["1"]), dateFormats: "month", dtVal: 1 },
        { id: 2, dtDisp: t("라벨.T_월", ["3"]), dateFormats: "month", dtVal: 3 },
        { id: 3, dtDisp: t("라벨.T_월", ["6"]), dateFormats: "month", dtVal: 6 },
        { id: 4, dtDisp: t("라벨.T_년", ["1"]), dateFormats: "year", dtVal: 1 },
    ];
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [dateSel, setDateSel] = useState(null);
    const [searchCount, setSearchCount] = useState({
        startDate: null,
        endDate: null,
    });
    // 등록 팝업
    useEffect(() => {
        // report
        handleOpenPop("pop-report", _jsx(ReportBasketsPop, { basketsItem: basketsItem, setBasketsItem: setBasketsItem, setWork: setWork }));
        // 검색
        handleOpenPop("pop-search-small", _jsx(SearchPop, { searchFieldList: searchFieldList, searchText: searchText, setSearchText: setSearchText, setSearchTextField: setSearchTextField }));
        // 공유
        handleOpenPop("pop-share", _jsx(SharePop, { checkItem: checkItem, treeSel: treeSel, repop: repop, htmlClose: _jsx(_Fragment, { children: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => PopClose("pop-share") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }) }));
        //삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, { checkItem: checkItem, setCheckItem: setCheckItem }));
        // 메모 등록/수정
        handleOpenPop("pop-memo-r1", _jsx(MemoPop, { memo: memo, setMemo: setMemo, listMemo: listMemo, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.리포트메모") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => MemoPopClose("pop-memo-r1") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
    }, [searchText, memo, listMemo, basketsItem, checkItem, treeSel, repop]);
    //  닫기
    function PopClose(id) {
        CUTIL.jsclose_Popup(id);
        setRepop(true);
    }
    function MemoPopClose(id) {
        CUTIL.jsclose_Popup(id);
        setMemo(true);
    }
    // Tree API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/subzone/filter`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: langIds.toString(),
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                let treeItem = data.body;
                if (treeItem.length > 0) {
                    if (!recoilTreeData.companyId) {
                        let curComapy = treeItem.filter((item) => item.zoneId == recoilState.zoneId).length > 0
                            ? treeItem.filter((item) => item.zoneId == recoilState.zoneId)[0]
                            : treeItem.filter((item) => item.companyId == recoilTreeTotal.companyId).length > 0
                                ? treeItem.filter((item) => item.companyId == recoilTreeTotal.companyId)[0]
                                : treeItem[0];
                        setRecoilTreeData(Object.assign(Object.assign({}, recoilTreeData), { companyId: curComapy.companyId, name: curComapy.name, subZoneId: curComapy.subZoneId }));
                        setRecoilState({
                            companyId: curComapy.companyId,
                            zoneId: curComapy.zoneId,
                        });
                        if (recoilState.zoneId && treeItem.filter((item) => item.zoneId == recoilState.zoneId).length <= 0) {
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.해당회사사업장정보없음") }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                    setTreeItem(treeItem);
                    // 초기화
                    if (!reloadspg) {
                        const today = new Date();
                        setStartDate(dayjs(today)
                            .set("year", dayjs(today).year() - dateTermList[4].dtVal)
                            .toDate());
                        setEndDate(today);
                        setDateSel(dateTermList[4].dtVal);
                        setSearchCount({
                            startDate: dayjs(today)
                                .set("year", dayjs(today).year() - dateTermList[4].dtVal)
                                .toDate(),
                            endDate: today,
                        });
                        handleCurPage(0);
                        setSearchText("");
                        setSearchTextField({
                            searchField: searchFieldList[0].sfVal,
                            searchText: "",
                        });
                        setSerarchInit(searchFieldList[0]);
                        setSortData({
                            sortField: "createdTime",
                            sort: "desc",
                        });
                        setCheckItem([]);
                        setCheckArr([]);
                    }
                    else {
                        setReloadspg(false);
                    }
                }
                else {
                    if (userInfo.role !== CONST.USERROLE_NONE) {
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "reset", type: CONST.TYPE_NONE, divTag: t("라벨.현재사업장이없어서운영관리화면으로이동합니다") }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    else {
                        navigate(CONST.URL_NOT_FOUND);
                    }
                    setRecoilState({
                        companyId: "",
                        zoneId: "",
                    });
                }
            }
            else {
                // data.body.map((err) => (err.msg));
            }
            setRecoilIsLoadingBox(false);
        }
    }, [data, reloadspg, langIds]);
    // 상세사업장
    function SubZoneClick(item) {
        setRecoilTreeData({
            companyId: item.companyId,
            name: item.name,
            subZoneId: item.subZoneId,
            roomId: recoilTreeData.subZoneId !== item.subZoneId ? "" : curTree.roomId,
            roomName: recoilTreeData.subZoneId !== item.subZoneId ? "" : curTree.roomName,
            spgId: recoilTreeData.subZoneId !== item.subZoneId ? -1 : curTree.spgId,
            spgName: recoilTreeData.subZoneId !== item.subZoneId ? "" : curTree.name,
        });
        setRecoilState({
            companyId: item.companyId,
            zoneId: item.zoneId,
        });
        if (recoilTreeData.subZoneId !== item.subZoneId) {
            setReloadspg(true);
        }
        setToogle(false);
    }
    //분전소
    function RoomSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/subzone/${recoilTreeData.subZoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setRoomInfo(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function onClickRoom(item) {
        if (item == "all") {
            setRecoilTreeData(Object.assign(Object.assign({}, recoilTreeData), { roomId: "", roomName: "" }));
        }
        else {
            setRecoilTreeData(Object.assign(Object.assign({}, recoilTreeData), { roomId: item.roomId, roomName: item.roomName }));
        }
        setSpgInfo([]);
        // setReload(true);
    }
    //spg select
    function SpgSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/${recoilTreeData.companyId}/spgs`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSpgInfo(data.body);
                    // setReload(false)
                }
                else {
                    // alert(data.errorList.map((err) => (err.msg)));
                }
            }
        });
    }
    function onClickSpg(item) {
        if (item === "all") {
            setRecoilTreeData(Object.assign(Object.assign({}, recoilTreeData), { spgId: -1, spgName: "" }));
        }
        else {
            setRecoilTreeData(Object.assign(Object.assign({}, recoilTreeData), { spgId: item.companySpgId, spgName: item.spgName }));
        }
    }
    // 날짜 기간조회
    function handleDayPop(days) {
        const today = new Date();
        if (days.dateFormats == "year") {
            setStartDate(dayjs(today)
                .set("year", dayjs(today).year() - days.dtVal)
                .toDate());
            setEndDate(today);
        }
        else if (days.dateFormats == "month") {
            setStartDate(dayjs(today)
                .set("month", dayjs(today).month() - days.dtVal)
                .toDate());
            setEndDate(today);
        }
        else {
            setStartDate(null);
            setEndDate(null);
        }
        setDateSel(days.id);
    }
    //조회 클릭
    function onClickSearchFilter(e) {
        if (!startDate && endDate) {
            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "시작 일자를 입력하세요" }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
        else if (!endDate && startDate) {
            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "종료 일자를 입력하세요" }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
        else {
            handleCurPage(0);
            setCurTree(recoilTreeData);
            setSearchCount({
                startDate: startDate,
                endDate: endDate,
            });
        }
    }
    // 검색 선택
    function SelectClick(item) {
        if (searchInit !== item) {
            setSearchText("");
            setSerarchInit(item);
        }
    }
    // 검색 버튼 이벤트
    function goSearch(e) {
        var schDiv = document.getElementById("mcheck_searchinput");
        var isSchMobile = schDiv.clientHeight <= 0 && schDiv.clientWidth <= 0 ? true : false;
        if (!isSchMobile) {
            const searchVal = {
                text: searchText,
                setSearch: setSearchTextField,
            };
            CUTIL.onClickSearch(searchVal);
        }
        else {
            CUTIL.jsopen_m_Popup(e);
        }
        handleCurPage(0);
    }
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            goSearch(e);
        }
    }
    // PDF다운로드
    function handleZipDownload(e) {
        if (checkArr.length < 2) {
            checkItem.map((list, idx) => __awaiter(this, void 0, void 0, function* () {
                // HTTPUTIL.fileDownload_WithPdfViewer(list.itemReportDto.serialNo, list.reportId, userInfo.loginInfo.token) // PDFView 링크이동
                HTTPUTIL.fileDownload_EhcReport(`${treeSel.code}_${recoilTreeData.name}_${list.itemReportDto.itemName}_${dayjs(list.updatedTime).format("YYYY-MM-DD")}`, list.reportId, userInfo.loginInfo.token);
            }));
        }
        else {
            let zipList = [];
            let zips = new JSZip();
            let zipCnt = 0;
            const zipFileName = `${treeSel.code}_${recoilTreeData.name}_${dayjs(new Date()).format("YYYY-MM-DD")}.zip`;
            checkItem.map((list, idx) => __awaiter(this, void 0, void 0, function* () {
                yield getSecondFileUrl(list)
                    .then((val) => {
                    if (val.codeNum === 200) {
                        zipList = zipList.concat({
                            fileName: `${decodeURI(treeSel.code + "_" + recoilTreeData.name + "_" + list.itemReportDto.itemName + "_" + dayjs(list.updatedTime).format("YYYY-MM-DD_HH:mm:ss"))}.PDF`,
                            fileLink: val.body.fileLink,
                        });
                    }
                    return {
                        codeNum: val.codeNum,
                        fileName: `${decodeURI(treeSel.code + "_" + recoilTreeData.name + "_" + list.itemReportDto.itemName + "_" + dayjs(list.updatedTime).format("YYYY-MM-DD_HH:mm:ss"))}.PDF`,
                        fileLink: val.body.fileLink,
                    };
                })
                    .then((val) => {
                    if (val.codeNum === 200) {
                        axios({
                            method: "GET",
                            url: val.fileLink,
                            responseType: "blob",
                        })
                            .then((resp) => {
                            zips.file(val.fileName, resp.data);
                            zipCnt++;
                            return zipCnt;
                        })
                            .then((zipCnt) => {
                            if (zipCnt === checkItem.length) {
                                zips.generateAsync({ type: "blob" }).then(function (blob) {
                                    // HTTPUTIL.fileDownload_EhcReport(zipFileName, list.reportId, userInfo.loginInfo.token)
                                    FILEUTILS.saveToFile_Chrome(zipFileName, blob); // 공유 연결시 해당 부분 변경
                                });
                            }
                        });
                    }
                });
            }));
        }
        setCheckItem([]);
        setCheckArr([]);
    }
    function getSecondFileUrl(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/report/${list.reportId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            return data;
        });
    }
    function PdfBasket(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let success = [];
            let fail = [];
            let data = [];
            setRecoilIsLoadingBox(true);
            for (let i = 0; i < checkItem.length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: `/assessment/basket`,
                    appQuery: {
                        reportType: "assessment",
                        reportTypeId: checkItem[i].assessmentId, // energyreportId 사용
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        success.push(data.body);
                    }
                    else {
                        fail.push(data.errorList);
                    }
                }
            }
            if (data) {
                setReloadState(true);
                setSuccess(success);
                setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-report", type: CONST.TYPE_NONE, pTag: {
                        p1: success.length > 0 ? t("라벨.건을장바구니에담았습니다", [success.length.toString()]) : "",
                        p2: fail.length > 0 ? t("라벨.건은장바구니에이미담겨져있습니다", [fail.length.toString()]) : "",
                    }, callBack: () => {
                        setCheckItem([]);
                        setCheckArr([]);
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        });
    }
    function MobileToogle(e) {
        if (!toogle) {
            setToogle(true);
            // CUTIL.selectFoucs("m" + recoilTreeData.name);
        }
        else {
            setToogle(false);
        }
    }
    function PopReport(e) {
        if (basketsItem && basketsItem.content.length > 0) {
            CUTIL.jsopen_Popup(e);
        }
        else {
            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.1개이상의Report가필요합니다") }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
    }
    const zoneOpen = (e) => {
        CUTIL.onClickSelect(e, CUTIL.selectOption);
        CUTIL.selectFoucs(recoilTreeData.name, { num: 0 });
    };
    // 평가 점수 토글 아웃포커싱
    useEffect(() => {
        const handleClick = (e) => {
            //e.preventDefault();
            const targetElement = e.target;
            const isBtn = targetElement.classList.contains("tooltip-link") || targetElement.closest(".tooltip-link");
            if (isBtn) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".tooltip-link");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("click");
                setAverageToogle(false);
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    // 트리 이외 다른곳 닫기
    useEffect(() => {
        const handleClick = (e) => {
            const targetElement = e.target;
            const isBtn = targetElement.classList.contains("select__toggleBtn") || targetElement.closest(".select__toggleBtn");
            if (isBtn) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".select__toggleBtn");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("active");
                setToogle(false);
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsxs("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: [_jsx("div", Object.assign({ className: "flex-inline gap-24 m-none" }, { children: _jsxs("div", Object.assign({ className: "select subZone", onClick: (e) => zoneOpen(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilTreeData.name })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: treeItem &&
                                            treeItem.map((item, idx) => (_jsxs("li", Object.assign({ className: recoilTreeData.name == item.name ? "active" : "", id: item.name, onClick: (e) => SubZoneClick(item), title: item.name }, { children: [item.name, " "] }), "userTree_" + idx.toString()))) })] })) })), _jsx("div", Object.assign({ className: `select__toggleBtn ${toogle ? "active" : ""} `, onClick: (e) => MobileToogle(e) }, { children: _jsx("p", { children: recoilTreeData.name }) })), _jsx("div", Object.assign({ className: `box selectbar menutype ${toogle ? "active" : ""}` }, { children: _jsx("div", Object.assign({ className: "manuarea" }, { children: _jsx("ul", Object.assign({ className: "manulist" }, { children: treeItem &&
                                        treeItem.map((item, idx) => (_jsx("li", Object.assign({ className: recoilTreeData.name == item.name ? "on" : "", id: "m" + item.name, onClick: (e) => SubZoneClick(item), title: item.name }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("p", { children: item.name }) })) }), "userTree_M" + idx.toString()))) })) })) }))] })), _jsxs("div", Object.assign({ className: `box__body ${pageInfo.totalElements == 0 ? "nodata" : ""}` }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "search" }, { children: _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("span", { children: _jsx("strong", { children: t("라벨.설비유형") }) }), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select spg w158", onClick: (e) => SpgSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilTreeData.spgId > 0 ? recoilTreeData.spgName : !reloadspg && t("라벨.전체") })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSpg("all"), title: t("라벨.전체") }, { children: t("라벨.전체") })), spgInfo.map((info) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSpg(info), title: info.spgName }, { children: info.spgName }), recoilTreeData.companyId + ":" + info.spgId)))] })] })) }))] }), _jsxs("li", { children: [_jsx("span", { children: _jsx("strong", { children: t("라벨.분전소명") }) }), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select room w158", onClick: (e) => RoomSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilTreeData.roomId ? recoilTreeData.roomName : !reloadspg && t("라벨.전체") })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickRoom("all"), title: t("라벨.전체") }, { children: t("라벨.전체") })), roomInfo &&
                                                                        roomInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickRoom(info), title: info.roomName }, { children: info.roomName }), "room_" + idx.toString())))] })] })) }))] }), _jsxs("li", { children: [_jsx("span", { children: _jsx("strong", { children: t("라벨.조회기간") }) }), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "searchterm" }, { children: [_jsxs("div", Object.assign({ className: "select term__month", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !reloadspg ? dateTermList[4].dtDisp : t("라벨.직접입력") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: dateTermList.map((dt, idx) => (_jsx("li", Object.assign({ id: "date_" + dt.id, className: "option", onClick: (e) => handleDayPop(dt) }, { children: dt.dtDisp }), `dt_${idx.toString()}`))) })] })), _jsxs("div", Object.assign({ className: "term__date" }, { children: [_jsx(DatePicker, { className: "calendar", locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: startDate, maxDate: endDate ? endDate : new Date(), onChange: (date) => setStartDate(date), withPortal: isMobile ? true : false, onFocus: (e) => (e.target.readOnly = true), readOnly: dateSel != 0 ? true : false }), _jsx("span", Object.assign({ className: "centerline" }, { children: "~" })), _jsx(DatePicker, { className: "calendar", locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: endDate, minDate: startDate, maxDate: new Date(), withPortal: isMobile ? true : false, onChange: (date) => setEndDate(date), onFocus: (e) => (e.target.readOnly = true), readOnly: dateSel != 0 ? true : false })] }))] })) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", onClick: (e) => onClickSearchFilter(e) }, { children: _jsx("span", { children: t("라벨.조회") }) }))] })] })) })) })), _jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsxs("div", Object.assign({ className: "right" }, { children: [_jsxs("div", Object.assign({ className: "searcharea m-none" }, { children: [_jsxs("div", Object.assign({ className: "searchinput", id: "mcheck_searchinput" }, { children: [_jsxs("div", Object.assign({ className: "select searchw", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: !reloadspg ? searchFieldList[0].sfDisp : t("라벨.전체") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList.map((sf, idx) => (_jsx("li", Object.assign({ id: "selects" + idx, onClick: (e) => SelectClick(sf), className: "option", "data-value": sf.sfVal }, { children: sf.sfDisp }), "search_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "input__direct w200" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-gray js-open-m", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) }))] })), _jsxs("div", Object.assign({ className: "btn__wrap" }, { children: [_jsxs("div", Object.assign({ className: "searcharea m-block" }, { children: [_jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsxs("div", Object.assign({ className: "select" }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: t("라벨.형명") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: _jsx("li", Object.assign({ className: "option" }, { children: t("라벨.형명") })) })] })), _jsxs("div", Object.assign({ className: "input__direct w200" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.텍스트입력") }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) }))] }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-blue js-open-m", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) }))] })), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic js-open", "data-pop": "pop-share", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", { children: t("라벨.공유") }) })), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic js-open", "data-pop": "pop-delete", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", { children: t("라벨.삭제") }) })), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic", onClick: (e) => handleZipDownload(e) }, { children: _jsxs("span", { children: ["PDF ", t("라벨.다운로드")] }) })), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic js-open", "data-pop": "pop-report", onClick: (e) => PdfBasket(e) }, { children: _jsx("span", { children: t("라벨.종합레포트담기") }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-sky btn-more", "data-pop": "pop-report", onClick: (e) => PopReport(e) }, { children: _jsxs("span", { children: [basketsItem && basketsItem.content.length > 0 ? basketsItem && basketsItem.content.length : "0", " ", _jsx("span", Object.assign({ className: "txt-black fontMedium" }, { children: t("라벨.담음") }))] }) }))] }))] })) })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("REPORT.NODATA") })), recoilTreeData.subZoneId && (_jsx(ReportList, { recoilTreeData: recoilTreeData, isMobile: isMobile, sortData: sortData, setSortData: setSortData, searchCount: searchCount, setSearchCount: setSearchCount, searchTextField: searchTextField, startDate: startDate, setStartDate: setStartDate, endDate: endDate, setEndDate: setEndDate, dateSel: dateSel, setDateSel: setDateSel, dateTermList: dateTermList, pageInfo: pageInfo, setPageInfo: setPageInfo, handleCurPage: handleCurPage, reportItem: reportItem, setReportItem: setReportItem, checkItem: checkItem, setCheckArr: setCheckArr, checkArr: checkArr, setCheckItem: setCheckItem, averageToogle: averageToogle, setAverageToogle: setAverageToogle, treeSel: treeSel, curTree: curTree, setListMemo: setListMemo }))] }))] })) }));
}
export default ReportView;
function ReportList(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const reloadspg = useRecoilValue(reloadSpg);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [report, setRort] = useRecoilState(reportTypeState);
    const langIds = useRecoilValue(langId);
    //props
    const { recoilTreeData, isMobile, sortData, setSortData, searchCount, searchTextField, pageInfo, setPageInfo, handleCurPage, reportItem, setReportItem, checkItem, setCheckArr, checkArr, setCheckItem, averageToogle, setAverageToogle, treeSel, curTree, setListMemo, } = props;
    let appPath = `subZoneId=${recoilTreeData.subZoneId}`;
    appPath = appPath + `&checkTypeName=${treeSel.codeName}`;
    appPath = appPath + `&sort=${sortData.sortField},${sortData.sort}`;
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    // 분전소
    if (curTree && curTree.roomId.length > 0) {
        appPath = appPath + `&roomId=${curTree.roomId}`;
    }
    // // spg
    if (curTree && curTree.spgId > 0) {
        appPath = appPath + `&companySpgList=${curTree.spgName}`;
    }
    // 조회 기간
    if (!CUTIL.isnull(searchCount.startDate) && !CUTIL.isnull(searchCount.endDate)) {
        appPath =
            appPath +
                `&startDate=${dayjs(searchCount.startDate).format("YYYYMMDD")}` +
                `&endDate=${dayjs(searchCount.endDate).format("YYYYMMDD")}`;
    }
    // 검색 필드
    if (searchTextField.searchText.length > 0) {
        appPath = appPath + `&searchKind=${searchTextField.searchField}&stringLike=${searchTextField.searchText}`;
    }
    // 기기목록 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/assessment/reports?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reloadspg + pageInfo + langIds,
    });
    useEffect(() => {
        if (data) {
            setRecoilIsLoadingBox(true);
            if (data.codeNum == CONST.API_200) {
                // setChnanTree(curTree);\
                setReportItem(data.body);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: isMobile ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, listReload: false })); //5, 10; //5, 10
            }
            setRecoilIsLoadingBox(false);
        }
        else {
            // alert(data.errorList.map((err) => (err.msg)));
        }
    }, [data, reloadspg, isMobile, langIds]);
    // 정렬 버튼 액션
    function onClickSort(e, sort) {
        if (e.target.nodeName !== "P") {
            // list 수정
            handleCurPage(0);
            const sortVal = {
                field: sort,
                data: sortData,
                setData: setSortData,
            };
            CUTIL.onClickSort(sortVal);
        }
    }
    function CheckedAll(checked) {
        if (checked) {
            const checks = checkItem.concat(reportItem.filter((checks) => checks.reportId));
            var unique = checks.filter((arr, index, callback) => index === callback.findIndex((txt) => txt.assessmentId === arr.assessmentId));
            const checksId = checkArr.concat(reportItem.filter((checks) => checks.reportId).map((item) => item.assessmentId));
            var uniqueId = checksId.filter((item, pos) => checksId.indexOf(item) === pos);
            setCheckArr(uniqueId);
            setCheckItem(unique);
        }
        else {
            let reportItemId = reportItem.map((item) => item.assessmentId);
            setCheckItem(checkItem.filter((item) => !reportItemId.includes(item.assessmentId)));
            setCheckArr(checkArr.filter((item) => !reportItemId.includes(item)));
        }
    }
    // checkbox
    function CheckedList(checked, list) {
        if (checked) {
            setCheckItem([...checkItem, list]);
            setCheckArr([...checkArr, list.assessmentId]);
        }
        else {
            setCheckItem(checkItem.filter((el) => el.assessmentId !== list.assessmentId));
            setCheckArr(checkArr.filter((el) => el !== list.assessmentId));
        }
    }
    // 평가 점수 토글
    function 평균점수Info(e) {
        if (averageToogle) {
            setAverageToogle(false);
        }
        else {
            setAverageToogle(true);
        }
    }
    function ReportView(item) {
        setRort(Object.assign(Object.assign({}, report), { checkType: "view", smenu: "assessment", assessmentId: item.assessmentId, checkSubTypeName: item.checkSubTypeName, checkTypeName: item.checkTypeName, checkVersionId: item.checkVersionId, companySpgName: item.companySpgName, panelName: item.panelName, reportId: item.reportId, roomName: item.roomName, subZoneName: item.subZoneName, totalComment: item.totalComment, totalScore: item.totalScore, itemReportDto: {
                itemId: item.itemReportDto.itemId,
                itemIdPk: item.itemReportDto.itemIdPk,
                itemName: item.itemReportDto.itemName,
                memo: item.itemReportDto.memo,
                responsible: item.itemReportDto.responsible,
                serialNo: item.itemReportDto.serialNo,
            } }));
    }
    function MemoListPop(e, list) {
        CUTIL.jsopen_Popup(e);
        setListMemo(list);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uADF8\uB8F9,\uC810\uAC80\uD56D\uBAA9,\uCE21\uC815\uC7A5\uBE44,\uC785\uB825\uBC29\uC2DD,\uAC00\uC911\uCE58,\uC810\uAC80\uAC00\uC774\uB4DC,\uCF54\uB4DC,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8  \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "sm-none" }, { children: [_jsx("col", { style: { width: "3%" } }), _jsx("col", { style: { width: "9%" } }), _jsx("col", { style: { width: "11%" } }), _jsx("col", { style: { width: "8%" } }), _jsx("col", { style: { width: "9%" } }), _jsx("col", { style: { width: "9%" } }), _jsx("col", { style: { width: "13%" } }), _jsx("col", { style: { width: "13%" } }), _jsx("col", { style: { width: "9%" } }), _jsx("col", { style: { width: "11%" } }), _jsx("col", { style: { width: "6%" } })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "col", className: "txt-left w6p" }, { children: [_jsx("input", { type: "checkbox", id: "st_all", checked: checkArr.length === 0
                                                    ? false
                                                    : reportItem.filter((checks) => checks.reportId).length ==
                                                        reportItem.filter((list) => checkArr.includes(list.assessmentId)).length
                                                        ? true
                                                        : false, onChange: (e) => CheckedAll(e.target.checked) }), _jsx("label", Object.assign({ htmlFor: "st_all" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "checkSubTypeName" && sortData.sort === "desc" ? "desc" : "asc"} sm-none`, onClick: (e) => onClickSort(e, "checkSubTypeName") }, { children: _jsx("span", { children: t("라벨.상세유형") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "subZoneName" && sortData.sort === "desc" ? "desc" : "asc"} sm-none`, onClick: (e) => onClickSort(e, "subZoneName") }, { children: _jsx("span", { children: t("라벨.상세사업장") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "roomName" && sortData.sort === "desc" ? "desc" : "asc"} m-none`, onClick: (e) => onClickSort(e, "roomName") }, { children: _jsx("span", { children: t("라벨.분전소") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "panelName" && sortData.sort === "desc" ? "desc" : "asc"} sm-none`, onClick: (e) => onClickSort(e, "panelName") }, { children: _jsx("span", { children: t("라벨.판넬") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "spgName" && sortData.sort === "desc" ? "desc" : "asc"} sm-none`, onClick: (e) => onClickSort(e, "spgName") }, { children: _jsx("span", { children: t("라벨.설비유형") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "itemName" && sortData.sort === "desc" ? "desc" : "asc"}` }, { children: _jsx("span", Object.assign({ onClick: (e) => onClickSort(e, "itemName") }, { children: t("라벨.형명") })) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "serialNo" && sortData.sort === "desc" ? "desc" : "asc"} m-none`, onClick: (e) => onClickSort(e, "serialNo") }, { children: _jsx("span", { children: t("라벨.시리얼번호") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "createdTime" && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort(e, "createdTime") }, { children: _jsx("span", { children: t("라벨.점검일자") }) })), _jsxs("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "totalScore" && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort(e, "totalScore") }, { children: [_jsxs("div", Object.assign({ className: "tooltip-wrap m-none" }, { children: [_jsx("p", { className: `tooltip-link right-m-90 ${averageToogle ? "click" : ""}`, onClick: (e) => 평균점수Info(e), "data-tooltip": averageToogle ? t("툴팁.평가점수") : "" }), _jsx("span", { children: t("라벨.평가점수") })] })), _jsx("div", Object.assign({ className: "tooltip-wrap m-block" }, { children: _jsx("span", { children: t("라벨.점수") }) }))] })), _jsx("th", Object.assign({ scope: "col", className: `sm-none` }, { children: _jsx("span", { children: t("라벨.메모") }) }))] }) }), _jsx("tbody", { children: reportItem.length > 0 &&
                                reportItem.map((list, idx) => (_jsxs("tr", Object.assign({ style: { cursor: "pointer" } }, { children: [_jsxs("td", { children: [_jsx("input", { type: "checkbox", id: "st_" + idx, checked: checkArr.includes(list.assessmentId) ? true : false, onChange: (e) => CheckedList(e.target.checked, list), disabled: list.reportId ? false : true, style: { display: "none" } }), _jsx("label", Object.assign({ htmlFor: "st_" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] }), _jsx("td", Object.assign({ className: "sm-none", onClick: (e) => ReportView(list) }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.checkSubTypeName ? list.checkSubTypeName : "-" })) })), _jsx("td", Object.assign({ className: "sm-none", onClick: (e) => ReportView(list) }, { children: list.subZoneName ? list.subZoneName : "-" })), _jsx("td", Object.assign({ className: "m-none", onClick: (e) => ReportView(list) }, { children: list.roomName ? list.roomName : "-" })), _jsx("td", Object.assign({ className: "sm-none", onClick: (e) => ReportView(list) }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.panelName ? list.panelName : "-" })) })), _jsx("td", Object.assign({ className: "sm-none", onClick: (e) => ReportView(list) }, { children: list.companySpgName ? list.companySpgName : "-" })), _jsx("td", Object.assign({ onClick: (e) => ReportView(list) }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.itemReportDto.itemName ? list.itemReportDto.itemName : "-" })) })), _jsx("td", Object.assign({ className: "m-none", onClick: (e) => ReportView(list) }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.itemReportDto.serialNo ? list.itemReportDto.serialNo : "-" })) })), _jsx("td", Object.assign({ onClick: (e) => ReportView(list) }, { children: list.updatedTime ? dayjs(list.createdTime).format("YYYY-MM-DD") : "-" })), _jsx("td", Object.assign({ onClick: (e) => ReportView(list) }, { children: _jsx("p", Object.assign({ className: `score-level ${list.alarmStatus == "SAFETY" ? "safety" : list.alarmStatus == "WARNING_SCORE" ? "danger" : ""}` }, { children: list.totalScore !== null ? list.totalScore : "-" })) })), _jsx("td", Object.assign({ className: "sm-none" }, { children: _jsx("button", Object.assign({ type: "button", className: `btn btn-comment m-0 js-open ${!list.assessmentMemo ? "icon-gray" : ""}`, "data-pop": "pop-memo-r1", onClick: (e) => MemoListPop(e, list) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uBA54\uBAA8" })) })) }))] }), "reportList_" + idx.toString()))) })] })) })), _jsx(EhpPagination, { componentName: "ASSESSMENTREPORT", pageInfo: pageInfo, handleCurPage: handleCurPage, checked: checkArr })] }));
}
function SearchPop(props) {
    const t = useTrans();
    // props
    const { searchFieldList, searchText, setSearchText, setSearchTextField } = props;
    const [searchBoolean, setSearchBoolean] = useState(false);
    // 모바일 취소 이벤트 및 초기화
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-search-small");
        setSearchText("");
        setSearchTextField({
            searchField: searchFieldList[0].sfVal,
            searchText: "",
        });
        setSearchBoolean(true);
    }
    // 진입 시 초기화 이벤트
    useEffect(() => {
        setSearchBoolean(false);
    }, [searchBoolean]);
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            handleGoSearch(e);
        }
    }
    function handleGoSearch(e) {
        const searchVal = {
            id: "pop-search-small",
            text: searchText,
            setSearch: setSearchTextField,
        };
        CUTIL.onClickSearch(searchVal);
        CUTIL.jsclose_Popup("pop-search-small");
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("div", Object.assign({ className: "form__input mb-0" }, { children: [_jsxs("div", Object.assign({ className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: !searchBoolean ? searchFieldList[0].sfDisp : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList.map((sf, idx) => (_jsx("li", Object.assign({ className: "option", "data-value": sf.sfVal }, { children: sf.sfDisp }), `sf_${idx.toString()}`))) })] })), _jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => handleGoSearch(e) }, { children: _jsx("span", { children: t("라벨.적용") }) }))] }))] }));
}
function SharePop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curReportState);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { checkItem, treeSel, repop } = props;
    //
    const [toMails, setToMails] = useState("");
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        if (repop) {
            shareClose("pop-share");
        }
    }, [repop]);
    function shareClose(id) {
        CUTIL.jsclose_Popup(id);
        setToMails("");
        setErrorList([]);
    }
    function handleSetUserId(e) {
        setErrorList([]);
        setToMails(e.target.value);
    }
    // PDF다운로드
    function handleZipDownload(e) {
        let zipList = [];
        let zips = new JSZip();
        let zipCnt = 0;
        const zipFileName = `${treeSel.code}_${recoilTreeData.name}_${dayjs(new Date()).format("YYYY-MM-DD")}.zip`;
        setRecoilIsLoadingBox(true);
        checkItem.map((list, idx) => __awaiter(this, void 0, void 0, function* () {
            yield getSecondFileUrl(list)
                .then((val) => {
                if (val.codeNum === 200) {
                    zipList = zipList.concat({
                        fileName: `${treeSel.code}_${recoilTreeData.name}_${list.itemReportDto.itemName}_${dayjs(list.updatedTime).format("YYYY-MM-DD_HH:mm:ss")}.PDF`,
                        fileLink: val.body.fileLink,
                    });
                }
                return {
                    codeNum: val.codeNum,
                    fileName: `${treeSel.code}_${recoilTreeData.name}_${list.itemReportDto.itemName}_${dayjs(list.updatedTime).format("YYYY-MM-DD_HH:mm:ss")}.PDF`,
                    fileLink: val.body.fileLink,
                };
            })
                .then((val) => {
                if (val.codeNum === 200) {
                    axios({
                        method: "GET",
                        url: val.fileLink,
                        responseType: "blob",
                    })
                        .then((resp) => {
                        zips.file(val.fileName, resp.data);
                        zipCnt++;
                        return zipCnt;
                    })
                        .then((zipCnt) => {
                        if (zipCnt === checkItem.length) {
                            zips.generateAsync({ type: "blob" }).then(function (blob) {
                                const email = { email: toMails };
                                linkShare(zipFileName, email, blob); // 공유 연결시 해당 부분 변경
                            });
                        }
                    });
                }
            });
        }));
    }
    function getSecondFileUrl(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/report/${list.reportId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            return data;
        });
    }
    function linkShare(zipFileName, email, content) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            const formData = new FormData();
            // 파일 데이터 저장
            const blob = new Blob([JSON.stringify(email)], { type: "application/json" });
            formData.append("email", blob);
            formData.append("file", content, zipFileName);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/assessment/report/zip/email`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.body }));
                    shareClose("pop-share");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    if (data.errorList) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList == null ? CONST.ERROR_MSG : data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            setRecoilIsLoadingBox(false);
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input w85p" }, { children: _jsxs("li", Object.assign({ className: "center" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "E-Mail" })), _jsxs("div", Object.assign({ className: "input__area w260" }, { children: [_jsx("input", { type: "text", id: "userId0", placeholder: "공유하실 이메일주소를 입력하세요.", className: errorList.filter((err) => err.field === "email").length > 0 ||
                                            errorList.filter((err) => err.field === "mail").length > 0
                                            ? "input-error"
                                            : "", value: toMails, onChange: (e) => handleSetUserId(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "email").length > 0
                                            ? errorList.filter((err) => err.field === "email").map((err) => err.msg)
                                            : errorList.filter((err) => err.field === "mail").length > 0 &&
                                                errorList.filter((err) => err.field === "mail").map((err) => err.msg) }))] }))] })) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => shareClose("pop-share") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "close", onClick: (e) => handleZipDownload(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadspg = useSetRecoilState(reloadSpg);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    //
    const { checkItem, setCheckItem } = props;
    function Delete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            let success = [];
            let fail = [];
            for (let i = 0; i < checkItem.length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "DELETE",
                    appPath: `/assessment/${checkItem[i].assessmentId}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        success.push(data.body);
                    }
                    else {
                        fail.push(data.errorList);
                    }
                }
            }
            if (success.length > 0 && fail.length <= 0) {
                setReloadspg(true);
                CUTIL.jsclose_Popup("pop-delete");
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.삭제되었습니다") }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setCheckItem([]);
                setReloadspg(false);
                setRecoilIsLoadingBox(false);
            }
            else if (success.length > 0 && fail.length > 0) {
                // need error handle
                setReloadspg(true);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, pTag: {
                        p1: `성공 ${success.length}건`,
                        p2: `실패 ${fail.length}건`,
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setCheckItem([]);
                setReloadspg(false);
                setRecoilIsLoadingBox(false);
            }
            else if (success.length <= 0 && fail.length > 0) {
                setReloadspg(true);
                CUTIL.jsclose_Popup("pop-delete");
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "오류로 인하여 삭제가 실패 하였습니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setReloadspg(false);
                setRecoilIsLoadingBox(false);
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uC120\uD0DD\uD55C \uB808\uD3EC\uD2B8\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => Delete(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function MemoPop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [reloadSpgs, setReloadSpgs] = useRecoilState(reloadSpg);
    // props
    const { listMemo, memo, setMemo } = props;
    // state
    const [reportMemo, setReportMemo] = useState("");
    useEffect(() => {
        // 메모 유무의 따른 이벤트
        if (listMemo) {
            setReportMemo(listMemo.assessmentMemo ? listMemo.assessmentMemo : "");
        }
        // 닫기의 따른 이벤트
        if (memo) {
            MemoClose("pop-memo-r1");
            setMemo(false);
        }
    }, [listMemo, memo]);
    function MemoClose(id) {
        CUTIL.jsclose_Popup(id);
        setReportMemo(listMemo.assessmentMemo ? listMemo.assessmentMemo : "");
    }
    function MemoUpdate(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/assessment/${listMemo.assessmentId}`,
                appQuery: {
                    isTempSave: false,
                    memo: reportMemo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadSpgs(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: `내용이 ${listMemo.assessmentMemo ? "수정" : "등록"} 되었습니다.` }));
                    MemoClose("pop-memo-r1");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadSpgs(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-memo-r1", type: CONST.TYPE_INNRE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-memo-r1");
                }
                setRecoilIsLoadingBox(false);
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.리포트메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h170", value: reportMemo, onChange: (e) => setReportMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setReportMemo) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [reportMemo ? reportMemo.length : 0, " / 400"] }))] }))] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => MemoClose("pop-memo-r1") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => MemoUpdate(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
